// Frontend route paths
export const PATH_LOGIN = "/login";
export const PATH_USERNOTFOUND = "/user-not-found";
export const PATH_DASHBOARD = "/dashboard";
export const PATH_CAREER_CARD = "/career-card";
export const PATH_REPORTEES = "/reportees";
export const PATH_SETTINGS = "/settings";
export const PATH_ADMIN = "/admin";
export const PATH_LOGOUT = "/logout";
export const PATH_MAINDASHBOARD = "/main-dashboard";
export const PATH_EMPLOYEEHIERARCHY = "/employeehierarchy";
export const PATH_GETDETAILS = "/getdetails";
export const PATH_NOTFOUND = "/*";
export const PATH_NOACCESS = "/unauthorized";
export const PATH_RELOGIN = "/relogin";